import { type ReactNode } from 'react'

export interface FormRadioButtonCirce {
  children: ReactNode
  disabled?: boolean
  value?: string
  onClick?: () => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  inputName: string
  description?: string
  labelClass?: string
  style?: number
  wrapperClass?: string
  wrapperLabelClassName?: string
  checked?: boolean
}

export function FormRadioButtonCirce({
  children,
  onClick = () => true,
  onChange,
  inputName,
  description,
  value,
  labelClass,
  style = 1,
  checked,
  disabled,
  wrapperClass,
  wrapperLabelClassName,
}: FormRadioButtonCirce) {
  return (
    <div
      className={`mb-[30px] pb-[30px] ${wrapperClass && wrapperClass} ${
        style === 1 ? 'border-b border-[#BDBDBD]' : 'form-check-default w-full'
      } `}
    >
      <div
        className={`flex items-center ${disabled ? 'cursor-not-allowed' : ''}`}
      >
        <input
          type='radio'
          onClick={onClick}
          onChange={onChange}
          className={`${
            style === 1
              ? 'mr-[12px] h-[20px] w-[20px] text-[#111111] accent-primary focus:shadow-none focus:outline-none focus:ring-0'
              : 'form-radio-input'
          }`}
          id={value}
          name={inputName}
          value={value}
          disabled={disabled}
          checked={checked}
        />
        <label
          htmlFor={value}
          className={`${
            style === 1 ? 'text-[14px] leading-[20px]' : 'form-radio-label'
          }  tracking-[0.02em] ${labelClass && labelClass}`}
        >
          {children}
        </label>
      </div>
      {description && (
        <div className={`ml-[32px] mt-[12px] ${wrapperLabelClassName}`}>
          <label
            htmlFor={value}
            className='text-[16px] font-[390] leading-[22px]'
          >
            {description}
          </label>
        </div>
      )}
    </div>
  )
}

export default FormRadioButtonCirce
